import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fieldTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-label',
		defaultMessage: 'Fields',
		description: 'Text for field tile title',
	},
	attachmentTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.attachment-tile-label',
		defaultMessage: 'Attachments',
		description: 'Text for attachment tile title',
	},
	commentsTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-label',
		defaultMessage: 'Comments',
		description: 'Text for comments tile title',
	},
	usersTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.users-tile-label',
		defaultMessage: 'Users',
		description: 'Text for Users tile title',
	},
	hierarchyTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-label',
		defaultMessage: 'Hierarchy',
		description: 'Text for hierarchy tile title',
	},
	statusTileLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-label',
		defaultMessage: 'Status mapping',
		description: 'Text for status mapping tile title',
	},
	fieldTileHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-heading',
		defaultMessage: 'Field mapping',
		description: 'Heading for the field Mapping tile',
	},
	attachmentTileHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.attachment-tile-heading',
		defaultMessage: 'Import all attachments',
		description: 'Heading for the import attachments tile',
	},
	hierarchyTileHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-heading',
		defaultMessage: 'Project hierarchy',
		description: 'Heading for the project hierarchy tile',
	},
	commentsTileHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-heading',
		defaultMessage: 'Import comments',
		description: 'Heading for the import comments tile',
	},
	hierarchyTileErrorDescription: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-error-description',
		defaultMessage: "We couldn't map your data. <link>Try again</link>",
		description:
			'Description for the hierarchy mapping tile when an error has occurred with the option to try again',
	},
	commentsTileEnabledDescription: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-enabled-description',
		defaultMessage:
			'Importing comments may take extra time. Some comment types will not be imported',
		description:
			'Description for the import comments tile indicating that it will take extra time and that some comments may not import',
	},
	fieldTileErrorDescription: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-error-description',
		defaultMessage: "We couldn't map your data. <link>Try again</link>",
		description:
			'Description for the field mapping tile when an error has occurred with the option to try again',
	},
	fieldTileDescription: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-description',
		defaultMessage:
			'{numFieldsIncluded}/{numFields} imported {numFields, plural, one {field is} other {fields are}} automatically mapped',
		description:
			'Description for the field mapping tile indicating how many fields are included in their import',
	},
	statusTileDescription: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-description',
		defaultMessage:
			'{numStatusesIncluded}/{numStatuses} imported {numStatuses, plural, one {status is} other {statuses are}} automatically mapped',
		description:
			'Description for the status mapping tile indicating how many statuses are included in their import',
	},
	statusTileLoadingDescriptionNonFinal: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-loading-description-non-final',
		defaultMessage: 'Mapping your statuses to Jira',
		description: 'Description for the status mapping tile when data is being loaded',
	},
	statusTileErrorDescriptionNonFinal: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-error-description-non-final',
		defaultMessage: "We couldn't map your statuses. <link>Try again</link>",
		description:
			'Description for the status mapping tile when an error has occurred with the option to try again',
	},
});
